export default "__VITE_ASSET__9aQH_ur8__"